import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/siYiGroupApi'

class Store {
  @observable loading = false
  @observable merchantInfo = {}
  @action
  getMerchantInfo = async () => {
    this.loading = true
    let { data } = await Api.merchantInfo()

    runInAction(() => {
      this.merchantInfo = data || {}
      this.loading = false
    })
  }
}
export default Store
